<script setup lang="ts">

import Loading from "@/components/atoms/Loading.vue";
import {computed} from "vue";

const props = defineProps<{
    disabled?: boolean,
    loading?: boolean,
    size?: 'small'|'medium'|'large',
    color?: 'primary'|'secondary',
}>()

const emit = defineEmits(['click'])

const sizeClass = computed(() => {
    return {
        small: ['h-25', 'text-xs'],
        medium: ['h-30', 'text-base'],
        large: ['h-35', 'text-base'],
    }[props.size ?? 'medium']
})

const colorClass = computed(() => {
    return {
        primary: ['bg-green', 'hover:bg-green-dark'],
        secondary: ['bg-red', 'hover:bg-red-dark'],
    }[props.color ?? 'primary']
})

const onClick = () => {
    if (!props.loading && !props.disabled) {
        emit('click')
    }
}

</script>

<template>

    <button @click.prevent.stop="onClick" :disabled="props.disabled || props.loading"
            class="flex items-center justify-center rounded border-none normal-case text-white font-bold shadow-sm relative overflow-hidden px-8 duration-300 active:scale-95 disabled:cursor-not-allowed"
            :class="[...colorClass, ...sizeClass]"
    >
        <template v-if="!props.loading">
            <slot></slot>
        </template>

        <Transition>
            <span v-if="props.loading" class="absolute inset-0 bg-blue flex items-center justify-center duration-300">
                <Loading></Loading>
                <slot name="loading"></slot>
            </span>
        </Transition>
    </button>

</template>
